import { useNavigate } from "react-router-dom";
import PermissionService from "../service/permission-service";

function Forbidden() {
    const navigate = useNavigate();
    const permissionService = new PermissionService();
    
    permissionService.findAllForCurrentUser().then(permissions => {
        sessionStorage.setItem('permissions', JSON.stringify(permissions));

        navigate("/");
    })

    return (<></>);
}

export default Forbidden;